setTimeout(() => {
    const form = document.getElementById('contactForm');
    if (form) {
        const emailInput = document.getElementById('contactEmail');
        const messageInput = document.getElementById('contactMessage');
        const agreementInput = document.getElementById('contactAggreement');
        const nameInput = document.getElementById('contactName');
        const submitBtn = document.getElementById('contactSubmit');
        const modal = document.querySelector('.contact__status-modal');
        const csrfToken = document.querySelector('input[name="_token"]').value;

        function isEmailValid(email) {
            return /^[^\s@]+@([^\s@]+\.)+[^\s@]+$/.test(email);
        }

        function showModalStatus(status) {
            ['sending', 'success', 'fail'].forEach(type => {
                modal.querySelector(`.contact__status-modal-text.${type}`).style.display = 'none';
            });
            modal.querySelector(`.contact__status-modal-text.${status}`).style.display = 'block';
        }

        function validateForm() {
            const emailValid = emailInput.value.trim().length > 0;
            const messageValid = messageInput.value.trim().length >= 10;
            const nameValid = nameInput.value.trim().length > 0;
            const agreementChecked = agreementInput.checked;

            if (emailValid && messageValid && nameValid && agreementChecked) {
                submitBtn.classList.add('active');
            } else {
                submitBtn.classList.remove('active');
            }
        }

        function handleEmailError(hasError) {
            emailInput.parentElement.classList.toggle('error', hasError);
        }

        function resetForm() {
            form.reset();
            agreementInput.checked = true;
            validateForm();
        }

        function closeModal() {
            modal.classList.remove('active');
        }

        async function submitHandler(e) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });

            if (!submitBtn.classList.contains('active')) return;

            const email = emailInput.value;
            emailInput.classList.add('error');
            if (!email || !isEmailValid(email)) {
                handleEmailError(true);
                return;
            } else {
                handleEmailError(false);
            }

            modal.classList.add('active');
            showModalStatus('sending');

            try {
                const formData = new FormData(form);
                const response = await fetch(form.action, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'X-CSRF-TOKEN': csrfToken
                    },
                    body: formData,
                });

                if (!response.ok) throw new Error('Network error');
                const data = await response.json();
                showModalStatus(data.status === 'success' ? 'success' : 'fail');
                if (data.status === 'success') {
                    resetForm();
                }
            } catch (error) {
                showModalStatus('fail');
                console.error(error);
            }
        }
        
        emailInput.addEventListener('input', validateForm);
        messageInput.addEventListener('input', validateForm);
        nameInput.addEventListener('input', validateForm);
        agreementInput.addEventListener('change', validateForm);
        form.addEventListener('submit', submitHandler);
        submitBtn.addEventListener('click', submitHandler);

        modal.querySelector('.contact__status-modal-close-btn').addEventListener('click', closeModal);

        validateForm();
    }
}, 500);